import { useLiveAnalyticsConfigFlag } from "src/flow/analytics/useLiveAnalyticsAccess";

type StandalonePerformanceAccess = {
  isEnabled: boolean;
  isLoading: boolean;
};

// Callers must hold off while `isLoading`: the live analytics config flag
// resolves to off until then, so the standalone page would flash before the
// redirect.
export const useStandalonePerformanceAccess =
  (): StandalonePerformanceAccess => {
    const { isEnabled: hasLiveAnalytics, isLoading } =
      useLiveAnalyticsConfigFlag();
    return { isEnabled: !hasLiveAnalytics, isLoading };
  };
